/* ==========================================================================
   POLYMERCRAFTS — MANUFACTURING PROCESS CAROUSEL JS CONTROLLER
   File: assets/process.js
   Description: Controls smooth touch swipe, mouse drag, and scroll snap 
   behavior for the mobile process track.
   ========================================================================== */

document.addEventListener('DOMContentLoaded', function () {
  initProcessCarousels();
});

// Shopify Theme Editor Section Load Event Support
document.addEventListener('shopify:section:load', function (event) {
  initProcessCarousels(event.target);
});

function initProcessCarousels(scope = document) {
  const processSections = scope.querySelectorAll('.sec__pc-process.enable-mobile-carousel');

  processSections.forEach((section) => {
    const grid = section.querySelector('.pc-process-grid');
    if (!grid) return;

    let isDown = false;
    let startX;
    let scrollLeft;

    // Mouse Drag Scrolling for Desktop / Editor Preview Testing
    grid.addEventListener('mousedown', (e) => {
      if (window.innerWidth >= 768) return;
      isDown = true;
      grid.classList.add('is-dragging');
      startX = e.pageX - grid.offsetLeft;
      scrollLeft = grid.scrollLeft;
    });

    grid.addEventListener('mouseleave', () => {
      isDown = false;
      grid.classList.remove('is-dragging');
    });

    grid.addEventListener('mouseup', () => {
      isDown = false;
      grid.classList.remove('is-dragging');
    });

    grid.addEventListener('mousemove', (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - grid.offsetLeft;
      const walk = (x - startX) * 1.5; // Scroll speed multiplier
      grid.scrollLeft = scrollLeft - walk;
    });
  });
}
